<template lang="pug">
		div
			Editor(v-if="editor", @cerrar="editor = null")
			router-view
</template>


<script>
import { mapMutations, mapGetters } from 'vuex'
import Editor from './components/editor/editor'
export default {
	components: {
		Editor
	},
	data () {
		return {
			editor: null
		}
	},
	created () {
		const menu = [
			{
				'icono': 'fa fa-address-card',
				'nombre': 'Fichar',
				activo: false,
				'callback': (a) => {
					this.editor = true
				}
			},
			{
				'icono': 'fa fa-list',
				'nombre': 'Registros',
				activo: true,
				'callback': (a) => {
					this.$router.push('/main/gestion-jornada/registros')
					this.setMenuActivo(a)
				}
			},
			{
				'icono': 'fa fa-file-pdf-o',
				'nombre': 'Informes',
				activo: false,
				'callback': (a) => {
					this.$router.push('/main/gestion-jornada/informes')
					this.setMenuActivo(a)
				}
			}
		]
		window.setTimeout(() => {
			this.setMenu(menu)
		}, 100)
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},
	methods: {
		...mapMutations({
			setMenu: 'top/setMenu',
			setMenuActivo: 'top/setMenuActivo'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/main.vue